import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len */
var Icon = function Icon() {
  return /*#__PURE__*/_jsxs("svg", {
    height: "22",
    viewBox: "0 0 15 22",
    width: "15",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Trash Icon"
    }), /*#__PURE__*/_jsxs("g", {
      "aria-hidden": "true",
      clipRule: "evenodd",
      fillRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m1.1 19.4c.1 1.5 1.3 2.6 2.8 2.6h7.2c1.5 0 2.7-1.1 2.8-2.6l1.1-12.4h-15zm11.5-10.1-.9 9.9c0 .3-.3.6-.6.6h-7.2c-.3 0-.6-.2-.6-.6l-.9-9.9z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m12 3.9c-.2-2.2-2.1-3.9-4.5-3.9s-4.3 1.7-4.5 3.9h-3v2.1h15v-2.1zm-6.7 0c.1-1 1.1-1.8 2.2-1.8s2.1.8 2.2 1.8z"
      })]
    })]
  });
};

export default Icon;